import { render, staticRenderFns } from "./FlyerThumbButtonVertical.vue?vue&type=template&id=7af24483&scoped=true&"
import script from "./FlyerThumbButtonVertical.vue?vue&type=script&lang=js&"
export * from "./FlyerThumbButtonVertical.vue?vue&type=script&lang=js&"
import style0 from "./FlyerThumbButtonVertical.vue?vue&type=style&index=0&id=7af24483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af24483",
  null
  
)

export default component.exports